import csvStringify from 'csv-stringify';

export const asyncCsvStringify = async (...args): Promise<string> => {
  return new Promise((resolve, reject) => {
    csvStringify(...args, (err, results) => {
      if (err) {
        return reject(err);
      }
      resolve(results);
    });
  });
};
